import { cloneDeep } from "lodash";
import qs from "qs";
export default function addHeaders(config, Etag) {
    if (config === void 0) { config = {}; }
    if (Etag === void 0) { Etag = ""; }
    var options = cloneDeep(config);
    if (!options.headers) {
        options.headers = {};
    }
    if (Etag) {
        options.headers["If-Match"] = Etag;
    }
    if (config.addCSRF) {
        /* eslint-disable quotes */
        var csrfElement = document.querySelector("meta[name=\"csrf\"]");
        /* eslint-enable quotes */
        if (csrfElement) {
            options.headers["csrf-token"] = csrfElement.content;
        }
    }
    if (!options.paramsSerializer) {
        options.paramsSerializer = function (params) { return qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }); };
    }
    return options;
}
